import * as React from "react";

type PdfOutputConfigurationDescriptionProps = {
  isArchived: boolean;
};
export const PdfOutputConfigurationDescription: React.FC<
  PdfOutputConfigurationDescriptionProps
> = ({ isArchived }) => (
  <div className="column has-text-left">
    <div className="field">
      <label className="label">
        帳票レイアウト
        <p className="help has-text-weight-normal">
          申請データや管理情報などの項目を、ドラッグ＆ドロップで、画像に自由に配置して使用できます。
          <br />
          作成したデータは、事務処理用に使用したり、申請者に送付したりできます。
          <br />
        </p>
        {isArchived && (
          <p className="help is-danger">
            アーカイブされた手続きの帳票レイアウトは、閲覧・編集できません。
          </p>
        )}
      </label>
    </div>
  </div>
);
